import { PropsWithChildren } from 'react';

import { Card, CardProps } from '@chakra-ui/react';

export function LegalSectionCard(props: PropsWithChildren<CardProps>) {
  const { children, ...cardProps } = props;

  return (
    <Card bgColor='white' borderRadius='4px 24px 4px 24px' boxShadow='md' padding='40px' {...cardProps}>
      {children}
    </Card>
  );
}
